import {
  Header,
  HeaderActionArea,
  Popover,
  PopoverButton,
  PopoverContent,
} from "@deere/fuel-react";
import {
  Box,
  Button,
  CircularProgress, Dialog, DialogActions, DialogTitle,
  Divider,
  Grid,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  TextField,
  Typography,
} from "@mui/material";
import {
  AccountCircleOutlined,
  AddCircleOutline,
  ExitToAppOutlined as ExitToAppOutlinedIcon,
  Language,
  PersonAdd,
  PersonAddDisabled,
  SettingsOutlined as SettingsOutlinedIcon,
  Visibility,
} from "@mui/icons-material";
import ContentPasteSearchIcon from "@mui/icons-material/ContentPasteSearch";
import Home from "@mui/icons-material/Home";
import { Avatar } from "@mui/material";
import { useOktaAuth } from "@okta/okta-react";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { getClientId, getIssuer } from "../../App";
import { isValidUser } from "../../components/validTPUser";
import {
  CREATE_TRANSACTION,
  DATA_ENTRY,
  DEERE_EMPLOYEE,
  EN_US_LOCALE,
  ES_ES_LOCALE,
  EXIT_SIMULATE_USER,
  FR_CA_LOCALE,
  HOME,
  PT_BR_LOCALE, SALES_MANAGER_ROLE,
  SALES_PERSON_ROLE,
  SEARCH_TRANSACTION,
  SIMULATE_USER,
} from "../../utilities/constants.js";
import { getUserName } from "../../utilities/tp-validations.js";
import { getLocale } from "../../utilities/utils";
import { isAuthorizedactivity } from "../Utility/isAuthorizedactivity";
import ToastUtility from "../Utility/toast-utility.js";

function TpHeader(props) {
  const history = useHistory();
  const { authState } = useOktaAuth();
  const [userObj, setUserObj] = useState({
    openSimulateUser: false,
    simulatedUserId: "",
    simulatedUserIdError: "",
  });
  const [toastObj, setToastObj] = useState({
    toastVariant: "default",
    toastDisplay: "none",
    toastMessage: "",
  });

  useEffect(() => {
    if (
      props.simulatedUserDetails &&
      Object.keys(props.simulatedUserDetails).length !== 0
    ) {
      if (props.simulatedUserDetails?.inValidUser) {
        setToastObj((prevObj) => ({
          ...prevObj,
          toastVariant: "error",
          toastDisplay: "inline",
          toastMessage: props.texts.ERR_USR_INCR,
        }));
        setTimeout(() => {
          setToastObj((prevObj) => ({
            ...prevObj,
            toastDisplay: "none",
          }));
        }, 5000);
        props.setIsSimulateMode(false);
      } else {
        setToastObj((prevObj) => ({
          ...prevObj,
          toastVariant: "success",
          toastDisplay: "inline",
          toastMessage:
            props.texts.SIMULATE_USER_AS +
            getUserName(props.simulatedUserDetails),
        }));
        setTimeout(() => {
          setToastObj((prevObj) => ({
            ...prevObj,
            toastDisplay: "none",
          }));
        }, 5000);
      }
      history.push("/");
    }
  }, [props.simulatedUserDetails]);

  const [attachmentRes, setAttachmentRes] = useState('');
  const [toastDisplay, setToastDisplay] = useState("none");

  useEffect(() => {
    if (props.transactionAttachmentResponse) {
      setAttachmentRes(props.transactionAttachmentResponse);
      setToastDisplay("inline");
      setTimeout(() => {
        setToastDisplay("none");
        props.clearAttachmentResponse();
      }, 10000);
    }
  }, [props.transactionAttachmentResponse]);

  const handleClose = () => {
    setUserObj((prevObj) => ({
      ...prevObj,
      openSimulateUser: false,
      simulatedUserId: "",
    }));
  };

  const handleClickSimulate = () => {
    if (userObj.simulatedUserId?.length === 7) {
      setToastObj((prevObj) => ({
        ...prevObj,
        toastVariant: "error",
        toastDisplay: "inline",
        toastMessage: props.texts.ERR_USR_INCR,
      }));
      setUserObj((prevObj) => ({
        ...prevObj,
        simulatedUserId: "",
      }));

      props.loadSimulation(userObj.simulatedUserId);
      handleClose();
    } else {
      setUserObj((prevObj) => ({
        ...prevObj,
        simulatedUserIdError: props.texts.ERR_SP_INCR,
      }));
    }
  };

  const handleOnClickLogout = () => {
    let issuer = getIssuer();
    let clientId = getClientId();
    let idToken = localStorage.getItem("okta-token-storage");
    if (idToken) {
      idToken = JSON.parse(idToken);
      idToken = idToken.idToken.idToken;
      window.location.href =
        issuer +
        "/v1/logout?client_id=" +
        clientId +
        "&id_token_hint=" +
        idToken +
        "&post_logout_redirect_uri=" +
        window.location.origin;
      localStorage.setItem("okta-token-storage", "");
      sessionStorage.setItem("showInfoToast", "inline");
    } else {
      console.log("Sorry Could not log out!!");
    }
  };

  const handleOnClickLangChang = (preferenceValue) => {
    const userId = props.isSimulateMode
      ? props.simulatedUserDetails.userId
      : props.userDetails.userId;
    const userPreference = {
      preferenceKey: "locale",
      preferenceValue,
      userId,
    };
    props.setUserPreferenceLocale(userPreference, props.isSimulateMode);
  };

  useEffect(() => {
    const { userDetails } = props;
    props.getUserDetailsFromOkta(userDetails);
    if (authState && userDetails?.userId) {
      props.fetchDomainDetails();
      props.loadBusinessActivities(userDetails.userId);
      props.getUserDetails(userDetails.userId);
      props.loadMachinesFromCache();
    }
  }, [authState]);

  const hasRole = (expectedRole) => {
    const userDetails = props.isSimulateMode
      ? props.simulatedUserDetails
      : props.userDetails;
    const authorizedRoles = userDetails?.authorizedRoles;
    const hasRoleValue =
      authorizedRoles && Object.values(authorizedRoles).includes(expectedRole);
    return hasRoleValue;
  };

  const getNavigationItems = () => {
    const validUser = isValidUser(props.businessActivities);
    if (!validUser) {
      return [];
    }
    const navigationItems = new Map();
    navigationItems.set(HOME.displayIndex, {
      label: props.texts.TP_HOME,
      onClick: () => {
        history.push("/");
      },
      startIcon: <Home />,
    });

    const authorizedActivities = props.isSimulateMode
      ? props.simulatedBusinessActivities
      : props.businessActivities;

    if (authorizedActivities && props.relatedAccount.authorized) {
      if (
        isAuthorizedactivity(
          CREATE_TRANSACTION.activityId,
          authorizedActivities
        )
      ) {
        navigationItems.set(CREATE_TRANSACTION.displayIndex, {
          label: props.texts.CREATE_TRAN,
          onClick: () => {
            props.resetCreateTransactionDetailsandResObj();
            props.clearCreateTransaction();
            props.setActionType("action", "Create");
            props.clearAllAttachments();
            history.push("/transaction");
          },
          startIcon: <AddCircleOutline />,
        });
      }
      if (props.isSimulateMode) {
        navigationItems.set(EXIT_SIMULATE_USER.displayIndex, {
          label: props.texts.EXIT_SIMULATION_FUNC,
          onClick: () => {
            handleClose();
            props.setIsSimulateMode(false);
            props.loadBusinessActivities(props.userDetails.userId);
            props.loadTranslatedTexts(getLocale(props.userDetails));
            props.resetSearchTxnAccountDropdowns();
            history.push("/");
          },
          startIcon: <PersonAddDisabled />,
        });
      } else if (
        isAuthorizedactivity(SIMULATE_USER.activityId, authorizedActivities)
      ) {
        navigationItems.set(SIMULATE_USER.displayIndex, {
          label: props.texts.TP_SIM_USER,
          onClick: () =>
            setUserObj((prevObj) => ({
              ...prevObj,
              openSimulateUser: true,
            })),
          startIcon: <PersonAdd />,
        });
      }

      if (
        isAuthorizedactivity(
          SEARCH_TRANSACTION.activityId,
          authorizedActivities
        )
      ) {
        navigationItems.set(SEARCH_TRANSACTION.displayIndex, {
          label: props.texts.SRCH_TRANSACTIONS,
          onClick: () => {
            props.setCreateTransactionResponseObj(null);
            props.clearAllAttachments();
            if (hasRole(DEERE_EMPLOYEE))
              props.fetchStoredParentDealerAccountDetails();
            if (!hasRole(DEERE_EMPLOYEE) && props.dealerAccount?.group3LeadId) {
              props.setSearchObj({
                ...props.searchObj,
                parentDealerAccountId : props.dealerAccount?.group3LeadId
              })
              if (hasRole(SALES_MANAGER_ROLE))
                props.fetchStoredDealerAccountDetails(props.dealerAccount?.group3LeadId);
              const userDetails = props.isSimulateMode
                  ? props.simulatedUserDetails
                  : props.userDetails;
              if (hasRole(SALES_PERSON_ROLE)) {
                props.fetchStoredDealerAccountDetails(props.dealerAccount?.group3LeadId, userDetails.userId, true);
              }
              if (hasRole(DATA_ENTRY))
                props.fetchStoredDealerAccountDetails(
                    props.dealerAccount.group3LeadId,
                    userDetails.userId,
                    false
                );
            }
            props.setTableVisibility(false);
            history.push("/transactions");
          },
          startIcon: <ContentPasteSearchIcon />,
        });
      }
    }
    const sortednavigationKeys = Array.from(navigationItems.keys()).sort();
    return sortednavigationKeys.map((key) => navigationItems.get(key));
  };

  return (
    <>
      {props.loadingValue || !props.userDetails?.userId ? (
        <Box display="flex" justifyContent="center" m={50}>
          <Box p={3}>
            <CircularProgress size="lg" variant="indeterminate" />
          </Box>
        </Box>
      ) : (
        <>
          <Header
            title={props.texts.TP_APP_TITLE}
            titleLink="/"
            navigationItems={getNavigationItems()}
          >
            <HeaderActionArea>
              <Popover>
                <PopoverButton>
                  {props.isSimulateMode ? (
                    <Visibility />
                  ) : (
                    <AccountCircleOutlined />
                  )}{" "}
                  &nbsp;&nbsp;
                  {props.isSimulateMode
                    ? getUserName(props.simulatedUserDetails)
                    : props.userDetails["name"]}
                </PopoverButton>
                <PopoverContent>
                  <Box minWidth="225px">
                    <Box display="flex" alignItems="center" p={4}>
                      <Avatar size="small"></Avatar>
                      <Box ml={3}>
                        <Typography
                          color="secondary"
                          fontWeight="semibold"
                          size="small"
                        >
                          {props.userDetails["name"]}
                        </Typography>
                      </Box>
                    </Box>
                    <Box>
                      <Divider />
                      <ListItemButton sx={{ pl: 5 }}>
                        <ListItemIcon>
                          <SettingsOutlinedIcon />
                        </ListItemIcon>
                        <ListItemText
                          primary={props.texts.ACCT_SETTINGS}
                          primaryTypographyProps={{
                            fontSize: "14px",
                            fontWeight: 600,
                            color: "#333",
                          }}
                        />
                      </ListItemButton>
                      <Divider />
                      <ListItemButton disableRipple disableTouchRipple>
                        <ListItemIcon>
                          <Language />
                        </ListItemIcon>
                        <ListItemText
                          primary={props.texts.LANGUGE}
                          primaryTypographyProps={{
                            fontSize: "14px",
                            fontWeight: 600,
                            color: "#333",
                          }}
                        />
                      </ListItemButton>
                      <ListItemButton
                        selected={props.texts.locale === EN_US_LOCALE}
                        onClick={() => handleOnClickLangChang("en_US")}
                      >
                        <ListItemText
                          primary={props.texts.ENGLISH}
                          primaryTypographyProps={{
                            fontSize: "14px",
                            fontWeight: 600,
                            color: "#333",
                            position: "relative",
                            left: "20%",
                          }}
                        />
                      </ListItemButton>
                      <ListItemButton
                        selected={props.texts.locale === PT_BR_LOCALE}
                        onClick={() => handleOnClickLangChang("pt_BR")}
                      >
                        <ListItemText
                          primary={props.texts.PORTUGUESE}
                          primaryTypographyProps={{
                            fontSize: "14px",
                            fontWeight: 600,
                            color: "#333",
                            position: "relative",
                            left: "20%",
                          }}
                        />
                      </ListItemButton>
                      <ListItemButton
                        selected={props.texts.locale === FR_CA_LOCALE}
                        onClick={() => handleOnClickLangChang("fr_CA")}
                      >
                        <ListItemText
                          primary={props.texts.FRENCH_LANGUAGE}
                          primaryTypographyProps={{
                            fontSize: "14px",
                            fontWeight: 600,
                            color: "#333",
                            position: "relative",
                            left: "20%",
                          }}
                        />
                      </ListItemButton>
                      <ListItemButton
                        selected={props.texts.locale === ES_ES_LOCALE}
                        onClick={() => handleOnClickLangChang("es_ES")}
                      >
                        <ListItemText
                          primary={props.texts.SPANISH_LANGUAGE}
                          primaryTypographyProps={{
                            fontSize: "14px",
                            fontWeight: 600,
                            color: "#333",
                            position: "relative",
                            left: "20%",
                          }}
                        />
                      </ListItemButton>
                      <Divider />
                      <ListItemButton
                        sx={{ pl: 5 }}
                        onClick={handleOnClickLogout}
                      >
                        <ListItemIcon>
                          <ExitToAppOutlinedIcon />
                        </ListItemIcon>
                        <ListItemText
                          primary={props.texts.SIGN_OUT_FUNC}
                          primaryTypographyProps={{
                            fontSize: "14px",
                            fontWeight: 600,
                            color: "#333",
                          }}
                        />
                      </ListItemButton>
                    </Box>
                  </Box>
                </PopoverContent>
              </Popover>
            </HeaderActionArea>
          </Header>
          <Dialog
            open={userObj.openSimulateUser}
            onClose={handleClose}
            aria-labelledby="alert-Modal-title"
            aria-describedby="alert-Modal-description"
          >
            <DialogTitle id="alert-Modal-title">
              {props.texts.TP_SIM_USER}
            </DialogTitle>
            <DialogActions>
              <Grid item xs>
                <TextField
                  size="md"
                  id="simulatedUserId"
                  placeholder={props.texts.ENTER_USER_ID}
                  value={userObj.simulatedUserId}
                  inputProps={{ maxLength: 7 }}
                  error={!!userObj.simulatedUserIdError}
                  helperText={userObj.simulatedUserIdError}
                  onChange={(event) =>
                    setUserObj((prevObj) => ({
                      ...prevObj,
                      simulatedUserId: event.target.value,
                    }))
                  }
                  onInput={(e) =>
                    (e.target.value = e.target.value
                      .replace(/[^a-zA-Z0-9]/g, "")
                      .toUpperCase())
                  }
                  onKeyDown={(event) => {
                    if (event.key === "Enter") {
                      handleClickSimulate();
                    }
                  }}
                />
              </Grid>
              <Button
                style={{ margin: "0px 10px" }}
                onClick={handleClickSimulate}
                variant="primary"
              >
                {props.texts.SIMULATE_FUNC}
              </Button>
            </DialogActions>
          </Dialog>
          <ToastUtility
            toastDisplay={toastObj.toastDisplay}
            toastVariant={toastObj.toastVariant}
            toastMessage={toastObj.toastMessage}
          />
        </>
      )}

      {props.transactionAttachmentResponse && (
          <ToastUtility
              topOffset="25%"
              toastDisplay={toastDisplay}
              toastVariant="error"
              toastMessage={attachmentRes}
          />
      )}
    </>
  );
}

export default TpHeader;
